import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ControlLayout, EnglishArabicDTO, FilterItem, FilterType, ForceDirection, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions, ToggleSlideOptions, DropdownOptions } from 'bnsights-control-library';
import { DataSecretService } from '../../shared/Services/data.service';
import { WorkflowService } from './../../shared/Services/WorkflowService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WFVariableModel } from '../../shared/models/WorkflowModels/WFVariableModel';
import { WorkflowVariablesService } from '../../shared/Services/WorkflowVariablesService.service';
import { WorkflowActivityService } from '../../shared/Services/WorkflowActivityService.service';
import { WFActivityModel } from '../../shared/models/WorkflowModels/WFActivityModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {

  ApiUrl: string = "/api/admin/WFVersion/"
  SubheaderTitle = "";
  ShowToolbar = false;
  ShowbreadCrumb = true;
  Url: string = "/Admin/Workflows"
  BreadcrumbTitle = this.utilityService.getResourceValue('Workflows');
  DetailsForm = new FormGroup({});
  ProductionMode: boolean;
  WorkflowDetails: any;
  WorkflowId: string;
  language: string;
  // Details Controls
  NameMultilingualTextBox: MultiLingualTextBoxOptions;
  DescriptionMultilingualTextBox: MultiLingualTextBoxOptions;
  Active: TextBoxOptions;
  Published: TextBoxOptions;
  SysName: TextBoxOptions;
  ShowWorkflowDetails: boolean = false;
  VersionId: string
  //Activity Controls
  @ViewChild('WorkflowActivityPagingViewElement', { static: false }) input: ElementRef;
  WorkflowActivityForm = new FormGroup({});
  WorkflowIdTextBox: TextBoxOptions;
  searchTextBox: TextBoxOptions;
  showFilter: boolean = false;
  WorkflowActivityPagingResult: any[] = [];
  WorkflowActivityPaging: PagingOptions;
  TextInputFilter: FilterItem;
  WorkflowIdFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ShowWorkflowVersion: boolean = false;
  //strat Workflow Variables

  WorkflowVariableApiUrl = "/api/admin/WorkflowVariable/"
  WorkflowVariablesearchTextBox: TextBoxOptions;
  DataTypeList = [];
  WorkflowVariableForm = new FormGroup({});
  WorkflowVariableshowFilter: boolean = false;
  WorkflowVariablePagingResult: any[] = [];
  WorkflowVariablePaging: PagingOptions;
  WorkflowVariableTextInputFilter: FilterItem;
  IsWorkflowVariableFilterLoaded: boolean = false;
  ShowWorkflowVariables: boolean = false

  VerisonIdTextBox: TextBoxOptions;
  VerisonIdTextInputFilter: FilterItem;
  Pagetitle: string = ""
  @ViewChild('WorkflowVariablePagingViewElement', { static: false }) WorkflowVariablePagingViewElement: ElementRef;

  //Add Model Controls
  AddWorkflowVariableForm = new FormGroup({});
  NameInEnglish: TextBoxOptions;
  NameInArabic: TextBoxOptions;
  SysNameWorkflowVariable: TextBoxOptions;
  DataType: DropdownOptions;
  IsAddWorkflowVariableFormLoaded: boolean;
  Constant: ToggleSlideOptions;
  @ViewChild('CloseWorkflowVariableModal', { static: false }) CloseWorkflowVariableModal: ElementRef;

  //Edit Model Controls
  EditWorkflowVariableForm = new FormGroup({});
  EditNameInEnglish: TextBoxOptions;
  EditNameInArabic: TextBoxOptions;
  EditSysNameWorkflowVariable: TextBoxOptions;
  EditDataType: DropdownOptions;
  EditConstant: ToggleSlideOptions;
  WorkflowVariableId: any
  @ViewChild('CloseEditWorkflowVariableModal', { static: false }) CloseEditWorkflowVariableModal: ElementRef;

  //End Workflow Variable



  //strat Workflow Activity

  ActivityApiUrl = "/api/admin/WorkflowActivity/"
  ActivityTypeList = [];
  workflowActivityForm = new FormGroup({});
  workflowActivityShowFilter: boolean = false;
  ActivityPagingResult: any[] = [];
  ActivityPaging: PagingOptions;
  IsworkflowActivityFilterLoaded: boolean = false;
  ShowWorkflowActivity: boolean = false
  WorkflowActivityIdTextBox: TextBoxOptions;
  WorkflowActivityIdFilter: FilterItem;
  @ViewChild('ActivityPagingViewElement', { static: false }) ActivityPagingViewElement: ElementRef;

  //Add Model Controls
  AddworkflowActivityForm = new FormGroup({});
  workflowActivityNameInEnglish: TextBoxOptions;
  workflowActivityNameInArabic: TextBoxOptions;
  workflowActivityDescriptionInEnglish: TextBoxOptions;
  workflowActivityDescriptionInArabic: TextBoxOptions;
  workflowActivitySysName: TextBoxOptions;
  ActivityType: DropdownOptions;
  @ViewChild('CloseworkflowActivityModal', { static: false }) CloseworkflowActivityModal: ElementRef;

  //Edit Model Controls
  EditworkflowActivityForm = new FormGroup({});
  EditworkflowActivityNameInEnglish: TextBoxOptions;
  EditworkflowActivityNameInArabic: TextBoxOptions;
  EditworkflowActivityDescriptionInEnglish: TextBoxOptions;
  EditworkflowActivityDescriptionInArabic: TextBoxOptions;
  EditworkflowActivitySysName: TextBoxOptions;
  EditActivityType: DropdownOptions;
  workflowActivityId: number
  @ViewChild('CloseEditworkflowActivityModal', { static: false }) CloseEditworkflowActivityModal: ElementRef;

  //End Workflow Activity



  // Decorator wires up blockUI instance
  ShowPageContent:boolean=false

  constructor(private dataServices: DataSecretService, private authService: AuthService, private WorkflowService: WorkflowService, private activatedRoute: ActivatedRoute, private router: Router, private WorkflowVariablesService: WorkflowVariablesService, private workflowActivityService: WorkflowActivityService, private pageInfoService: PageInfoService, private modalService: NgbModal, private environmentService: EnvironmentService, private bbsfTranslateService: BBSFTranslateService,
    public utilityService: UtilityService) {
    this.activatedRoute.params.subscribe(params => {
      this.WorkflowId = params['id'];
      this.VersionId = params['vid'];

    });
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.getDetails();

  }

  getDetails() {
    this.ShowWorkflowDetails = false;
    this.ShowWorkflowVersion = false;
    this.ShowWorkflowActivity = false;
    this.ShowWorkflowVariables = false;
    this.IsFilterLoaded = false
    this.IsWorkflowVariableFilterLoaded = false
    this.IsworkflowActivityFilterLoaded = false;
    this.WorkflowService.GetDetails(this.WorkflowId).subscribe((result) => {
      this.WorkflowDetails = result as any
      this.NameMultilingualTextBox = new MultiLingualTextBoxOptions();
      this.NameMultilingualTextBox.ArabicLabelKey = "NameInArabic"
      this.NameMultilingualTextBox.EnglishLabelKey = "NameInEnglish"
      this.NameMultilingualTextBox.IsRequired = true;
      this.NameMultilingualTextBox.Name = "Name";
      var Name = new EnglishArabicDTO();
      Name.Arabic = this.WorkflowDetails.name.arabic;
      Name.English = this.WorkflowDetails.name.english;
      if (this.language == 'en') {
        this.Pagetitle = Name.English
      }
      else {
        this.Pagetitle = Name.Arabic
      }

      PageInfoService.PageTitle = this.Pagetitle
      PageInfoService.PageBreadcrumbs = [
        { title: this.utilityService.getResourceValue("Home"), path: '/Admin/Home', isSeparator: false, isActive: false },
        { title: '', path: '', isSeparator: true, isActive: false },
        { title: this.utilityService.getResourceValue("Workflows"), path: '/Admin/Workflows/workflow', isSeparator: false, isActive: false },
        { title: '', path: '', isSeparator: true, isActive: false }

      ];

      this.pageInfoService.calculateTitle();
      this.pageInfoService.calculateBreadcrumbs();


      this.NameMultilingualTextBox.Value = Name;
      this.NameMultilingualTextBox.IsDisabled = true

      this.DescriptionMultilingualTextBox = new MultiLingualTextBoxOptions();
      this.DescriptionMultilingualTextBox.ArabicLabelKey = "DescriptionInArabic"
      this.DescriptionMultilingualTextBox.EnglishLabelKey = "DescriptionInEnglish"
      this.DescriptionMultilingualTextBox.IsRequired = true;
      this.DescriptionMultilingualTextBox.Name = "Description";
      var Description = new EnglishArabicDTO();
      Description.Arabic = this.WorkflowDetails.description.arabicValue;
      Description.English = this.WorkflowDetails.description.englishValue;
      this.DescriptionMultilingualTextBox.Value = Description;
      this.DescriptionMultilingualTextBox.IsDisabled = true

      this.SysName = new TextBoxOptions();
      this.SysName.Name = "SysName"
      this.SysName.LabelKey = "SysName"
      this.SysName.Type = InputType.Text
      this.SysName.IsDisabled = true
      this.SysName.Value = this.WorkflowDetails.sysName

      this.Active = new TextBoxOptions();
      this.Active.Name = "Active"
      this.Active.LabelKey = "Active"
      this.Active.Type = InputType.Text
      this.Active.IsDisabled = true
      this.Active.Value = this.WorkflowDetails.isActive

      this.Published = new TextBoxOptions();
      this.Published.Name = "Published"
      this.Published.LabelKey = "Published"
      this.Published.Type = InputType.Text
      this.Published.IsDisabled = true
      this.Published.Value = this.WorkflowDetails.isPublished

      this.ShowWorkflowVersion = false;
      this.ShowWorkflowActivity = false;
      this.ShowWorkflowVariables = false;
      this.IsFilterLoaded = false
      this.IsWorkflowVariableFilterLoaded = false
      this.IsworkflowActivityFilterLoaded = false;


      this.ShowWorkflowDetails = true;
      this.utilityService.stopBlockUI();

    }, (error) => {
      this.utilityService.stopBlockUI();
    })
  }

  
  GetVersions() {
    this.ShowWorkflowDetails = false;
    this.ShowWorkflowVersion = false;
    this.ShowWorkflowActivity = false;
    this.ShowWorkflowVariables = false;
    this.IsFilterLoaded = false
    this.IsWorkflowVariableFilterLoaded = false
    this.IsworkflowActivityFilterLoaded = false;

    this.utilityService.startBlockUI()
    // TextBox inti

    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
    this.searchTextBox.HideLabel = true


    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox


    this.WorkflowIdTextBox = new TextBoxOptions();
    this.WorkflowIdTextBox.Name = "WorkflowIdTextBox"
    this.WorkflowIdTextBox.HideLabel = true
    this.WorkflowIdTextBox.Type = InputType.Text
    this.WorkflowIdTextBox.Value = this.WorkflowId

    this.WorkflowIdFilter = new FilterItem();
    this.WorkflowIdFilter.FormControlName = "WorkflowIdTextBox"
    this.WorkflowIdFilter.ActionParameterName = "WfID"
    this.WorkflowIdFilter.IsFormControl = true
    this.WorkflowIdFilter.FilterType = FilterType.TextBox

    this.WorkflowActivityPaging = new PagingOptions();
    this.WorkflowActivityPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetVersionsListing';
    this.WorkflowActivityPaging.OnKeyPressFiltersControlNames = ["searchTextBox", "WorkflowIdTextBox"]
    this.WorkflowActivityPaging.Filters = [this.TextInputFilter, this.WorkflowIdFilter]
    this.WorkflowActivityPaging.ValidationToken =this.authService.authorizationHeaderValue()

    this.ShowWorkflowDetails = false;
    this.ShowWorkflowVersion = true;
    this.ShowWorkflowActivity = false;
    this.ShowWorkflowVariables = false;
    this.IsWorkflowVariableFilterLoaded = false
    this.IsworkflowActivityFilterLoaded = false;

    setTimeout(() => {

      this.IsFilterLoaded = true;
      this.utilityService.stopBlockUI();
    }, 10);
  }

  setWorkflowActivityListResult(result) {
    this.utilityService.stopBlockUI();
    this.WorkflowActivityPagingResult = result
  }

  resetFilters() {
    this.WorkflowActivityForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  //WF variables Functions

  setWorkflowVariableListResult(result) {
    this.utilityService.stopBlockUI();

    this.WorkflowVariablePagingResult = result
  }
  resetWorkflowVariableFilters() {
    this.WorkflowVariableForm.controls["searchTextBox"].setValue(null);
    let element = this.WorkflowVariablePagingViewElement as any;
    this.utilityService.stopBlockUI();
    element.ReinitializePaging();

  }
  LoadWorkflowVariables() {
    this.WorkflowVariablesService.Loaddropdowns().subscribe((result) => {


      let DataTypeList = result as any
      this.DataTypeList = DataTypeList

      // TextBox inti
      this.WorkflowVariablesearchTextBox = new TextBoxOptions();
      this.WorkflowVariablesearchTextBox.Name = "WorkflowVariablesearchTextBox"
      this.WorkflowVariablesearchTextBox.Type = InputType.Text
      this.WorkflowVariablesearchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.WorkflowVariablesearchTextBox.HideLabel = true;


      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "WorkflowVariablesearchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.VerisonIdTextBox = new TextBoxOptions();
      this.VerisonIdTextBox.Name = "VerisonIdTextBox"
      this.VerisonIdTextBox.HideLabel = true
      this.VerisonIdTextBox.Type = InputType.Text
      this.VerisonIdTextBox.Value = this.WorkflowId

      this.VerisonIdTextInputFilter = new FilterItem();
      this.VerisonIdTextInputFilter.FormControlName = "VerisonIdTextBox"
      this.VerisonIdTextInputFilter.ActionParameterName = "versionID"
      this.VerisonIdTextInputFilter.IsFormControl = true
      this.VerisonIdTextInputFilter.FilterType = FilterType.TextBox

      this.WorkflowVariablePaging = new PagingOptions();
      this.WorkflowVariablePaging.ActionPostURL = this.environmentService.getApiUrl() + this.WorkflowVariableApiUrl + 'GetVariableListing';
      this.WorkflowVariablePaging.OnKeyPressFiltersControlNames = ["WorkflowVariablesearchTextBox", "VerisonIdTextBox"]
      this.WorkflowVariablePaging.Filters = [this.TextInputFilter, this.VerisonIdTextInputFilter]
      this.WorkflowVariablePaging.ValidationToken = this.authService.authorizationHeaderValue()

      this.ShowWorkflowDetails = false;
      this.ShowWorkflowVersion = false;
      this.ShowWorkflowActivity = false;
      this.ShowWorkflowVariables = true;
      this.IsFilterLoaded = false
      this.IsworkflowActivityFilterLoaded = false;
      setTimeout(() => {

        this.IsWorkflowVariableFilterLoaded = true
        this.utilityService.stopBlockUI();

      }, 10);
    })
  }

  showAddWorkflowVariableModal(AddWorkflowVariableModal) {
    this.utilityService.startBlockUI();
    this.AddWorkflowVariableForm = new FormGroup({})

    this.NameInEnglish = new TextBoxOptions();
    this.NameInEnglish.Name = "NameInEnglish";
    this.NameInEnglish.LabelKey = "NameInEnglish";
    this.NameInEnglish.Type = InputType.Text;
    this.NameInEnglish.Value = null;
    this.NameInEnglish.IsRequired = true;


    this.NameInArabic = new TextBoxOptions();
    this.NameInArabic.Name = "NameInArabic";
    this.NameInArabic.LabelKey = "NameInArabic";
    this.NameInArabic.Type = InputType.Text;
    this.NameInArabic.Value = null;
    this.NameInArabic.IsRequired = true;
    this.NameInArabic.ForceDirection = ForceDirection.Arabic;

    this.SysNameWorkflowVariable = new TextBoxOptions();
    this.SysNameWorkflowVariable.Name = "SysName";
    this.SysNameWorkflowVariable.LabelKey = "SysName";
    this.SysNameWorkflowVariable.Type = InputType.Text;
    this.SysNameWorkflowVariable.Value = null;

    this.DataType = new DropdownOptions();
    this.DataType.Name = "DataType"
    this.DataType.LabelKey = "DataType"
    this.DataType.DataSource = this.DataTypeList
    this.DataType.SingleSelection = true;
    this.DataType.AllowSearchFilter = true;
    this.DataType.Placeholder = "";
    this.modalService.open(AddWorkflowVariableModal);
    this.utilityService.stopBlockUI();

    this.Constant = new ToggleSlideOptions();
    this.Constant.Name = "Constant"
    this.Constant.LabelKey = "Constant"
    this.Constant.ViewType = ControlLayout.Horizontal

  }
  addWorkflowVariable() {
    if (this.AddWorkflowVariableForm.invalid) {
      return;
    }
    else {

      this.utilityService.startBlockUI();
      let ResultModel = this.AddWorkflowVariableForm.value;
      //console.log(ResultModel)
      let addModel = new WFVariableModel();
      addModel.Name.English = ResultModel.NameInEnglish
      addModel.Name.Arabic = ResultModel.EnglishValue
      addModel.SysName = ResultModel.SysName
      addModel.WorkflowVersionID = Number(this.VersionId);
      addModel.DataTypeItemID = ResultModel.DataType != null ? Number(ResultModel.DataType) : null
      addModel.IsConstant = ResultModel.Constant
      this.WorkflowVariablesService.AddVariable( addModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.WorkflowVariablePagingViewElement as any;
        element.ReinitializePaging();
      }, (error) => {
       
      })
    }
  }

  showEditWorkflowVariableModal(WorkflowVariable: any, EditWorkflowVariableModal) {
    this.utilityService.startBlockUI();
    this.EditWorkflowVariableForm = new FormGroup({})

    this.WorkflowVariableId = WorkflowVariable.id

    this.EditNameInEnglish = new TextBoxOptions();
    this.EditNameInEnglish.Name = "EditNameInEnglish";
    this.EditNameInEnglish.LabelKey = "NameInEnglish";
    this.EditNameInEnglish.Type = InputType.Text;
    this.EditNameInEnglish.Value = WorkflowVariable.name.english;
    this.EditNameInEnglish.IsRequired = true;


    this.EditNameInArabic = new TextBoxOptions();
    this.EditNameInArabic.Name = "EditNameInArabic";
    this.EditNameInArabic.LabelKey = "NameInArabic";
    this.EditNameInArabic.Type = InputType.Text;
    this.EditNameInArabic.Value = WorkflowVariable.name.arabic;
    this.EditNameInArabic.IsRequired = true;
    this.EditNameInArabic.ForceDirection = ForceDirection.Arabic;

    this.EditSysNameWorkflowVariable = new TextBoxOptions();
    this.EditSysNameWorkflowVariable.Name = "EditSysName";
    this.EditSysNameWorkflowVariable.LabelKey = "SysName";
    this.EditSysNameWorkflowVariable.Type = InputType.Text;
    this.EditSysNameWorkflowVariable.Value = WorkflowVariable.sysName;

    this.EditDataType = new DropdownOptions();
    this.EditDataType.Name = "EditDataType"
    this.EditDataType.LabelKey = "DataType"
    this.EditDataType.DataSource = this.DataTypeList
    this.EditDataType.SingleSelection = true;
    this.EditDataType.AllowSearchFilter = true;
    this.EditDataType.Placeholder = "";
    this.EditDataType.SelectedItems = this.DataTypeList.filter((item) => { return parseInt(item.key) == WorkflowVariable.dataTypeItemID; }).map((item) => item.key)[0];;

    this.EditConstant = new ToggleSlideOptions();
    this.EditConstant.Name = "EditConstant"
    this.EditConstant.LabelKey = "Constant"
    this.EditConstant.Value = WorkflowVariable.isConstant
    this.EditConstant.ViewType = ControlLayout.Horizontal

    this.modalService.open(EditWorkflowVariableModal);
    this.utilityService.stopBlockUI();

  }
  editWorkflowVariable() {
    if (this.EditWorkflowVariableForm.invalid) {
      return;
    }
    else {
      this.utilityService.startBlockUI();
      let ResultModel = this.EditWorkflowVariableForm.value;
      let EditModel = new WFVariableModel();
      EditModel.ID = Number(this.WorkflowVariableId);
      EditModel.Name.English = ResultModel.EditNameInEnglish
      EditModel.Name.Arabic = ResultModel.EditNameInArabic
      EditModel.SysName = ResultModel.EditSysName
      EditModel.WorkflowVersionID = Number(this.VersionId);
      EditModel.DataTypeItemID = ResultModel.EditDataType != null ? Number(ResultModel.EditDataType) : null
      EditModel.IsConstant = ResultModel.EditConstant

      this.WorkflowVariablesService.EditVariable(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.WorkflowVariablePagingViewElement as any;
        element.UpdatePaging();
      }, (error) => {
      
      })
    }
  }



  //WF Activitities Functions


  setActivityListResult(result) {
    this.ActivityPagingResult = result
  }
  resetworkflowActivityFilters() {
    this.workflowActivityForm.controls["searchTextBox"].setValue(null);
    let element = this.ActivityPagingViewElement as any;
    element.ReinitializePaging();

  }

  LoadworkflowActivity() {
    // this.IsworkflowActivityFilterLoaded = false;


    this.utilityService.startBlockUI()

    this.workflowActivityService.Loaddropdowns().subscribe((result) => {


      let ActivityList = result as any
      this.ActivityTypeList = ActivityList

      this.WorkflowActivityIdTextBox = new TextBoxOptions();
      this.WorkflowActivityIdTextBox.Name = "WorkflowActivityIdTextBox"
      this.WorkflowActivityIdTextBox.HideLabel = true
      this.WorkflowActivityIdTextBox.Type = InputType.Text
      this.WorkflowActivityIdTextBox.Value = this.WorkflowId

      this.WorkflowActivityIdFilter = new FilterItem();
      this.WorkflowActivityIdFilter.FormControlName = "WorkflowActivityIdTextBox"
      this.WorkflowActivityIdFilter.ActionParameterName = "WfID"
      this.WorkflowActivityIdFilter.IsFormControl = true
      this.WorkflowActivityIdFilter.FilterType = FilterType.TextBox

      this.ActivityPaging = new PagingOptions();
      this.ActivityPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ActivityApiUrl + 'GetWorkflowActivityListing';
      this.ActivityPaging.OnKeyPressFiltersControlNames = ["WorkflowActivityIdTextBox"]
      this.ActivityPaging.Filters = [this.WorkflowActivityIdFilter]
      this.ActivityPaging.ValidationToken = this.authService.authorizationHeaderValue()

      this.ShowWorkflowDetails = false;
      this.ShowWorkflowVersion = false;
      this.ShowWorkflowActivity = true;
      this.ShowWorkflowVariables = false;
      this.IsFilterLoaded = false
      this.IsWorkflowVariableFilterLoaded = false

      setTimeout(() => {


        this.IsworkflowActivityFilterLoaded = true;

        this.utilityService.stopBlockUI();

      }, 10);
    })
  }

  showAddworkflowActivityModal(AddWorkflowActivityModal) {
    this.utilityService.startBlockUI();
    this.AddworkflowActivityForm = new FormGroup({})

    this.workflowActivityNameInEnglish = new TextBoxOptions();
    this.workflowActivityNameInEnglish.Name = "NameInEnglish";
    this.workflowActivityNameInEnglish.LabelKey = "NameInEnglish";
    this.workflowActivityNameInEnglish.Type = InputType.Text;
    this.workflowActivityNameInEnglish.Value = null;
    this.workflowActivityNameInEnglish.IsRequired = true;

    this.workflowActivityNameInArabic = new TextBoxOptions();
    this.workflowActivityNameInArabic.Name = "NameInArabic";
    this.workflowActivityNameInArabic.LabelKey = "NameInArabic";
    this.workflowActivityNameInArabic.Type = InputType.Text;
    this.workflowActivityNameInArabic.Value = null;
    this.workflowActivityNameInArabic.IsRequired = true;
    this.workflowActivityNameInArabic.ForceDirection = ForceDirection.Arabic;


    this.workflowActivityDescriptionInEnglish = new TextBoxOptions();
    this.workflowActivityDescriptionInEnglish.Name = "DescriptionInEnglish";
    this.workflowActivityDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.workflowActivityDescriptionInEnglish.Type = InputType.Text;
    this.workflowActivityDescriptionInEnglish.Value = null;
    this.workflowActivityDescriptionInEnglish.IsRequired = true;

    this.workflowActivityDescriptionInArabic = new TextBoxOptions();
    this.workflowActivityDescriptionInArabic.Name = "DescriptionInArabic";
    this.workflowActivityDescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.workflowActivityDescriptionInArabic.Type = InputType.Text;
    this.workflowActivityDescriptionInArabic.Value = null;
    this.workflowActivityDescriptionInArabic.IsRequired = true;
    this.workflowActivityDescriptionInArabic.ForceDirection = ForceDirection.Arabic;


    this.workflowActivitySysName = new TextBoxOptions();
    this.workflowActivitySysName.Name = "SysName";
    this.workflowActivitySysName.LabelKey = "SysName";
    this.workflowActivitySysName.Type = InputType.Text;
    this.workflowActivitySysName.Value = null;

    this.ActivityType = new DropdownOptions();
    this.ActivityType.Name = "ActivityType"
    this.ActivityType.LabelKey = "ActivityType"
    this.ActivityType.DataSource = this.ActivityTypeList
    this.ActivityType.SingleSelection = true;
    this.ActivityType.AllowSearchFilter = true;
    this.ActivityType.Placeholder = "";
    this.modalService.open(AddWorkflowActivityModal);
    this.utilityService.stopBlockUI();

  }
  addworkflowActivity() {
    if (this.AddworkflowActivityForm.invalid) {
      return;
    }
    else {

      this.utilityService.startBlockUI();
      let ResultModel = this.AddworkflowActivityForm.value;
      //console.log(ResultModel)
      let addModel = new WFActivityModel();
      addModel.Name.English = ResultModel.NameInEnglish
      addModel.Name.Arabic = ResultModel.NameInArabic
      addModel.Description.English = ResultModel.DescriptionInEnglish
      addModel.Description.Arabic = ResultModel.DescriptionInArabic
      addModel.SysName = ResultModel.SysName
      addModel.VersionID = Number(this.VersionId);
      addModel.ActivityTypeItemID = ResultModel.ActivityType != null ? Number(ResultModel.ActivityType) : null
      this.workflowActivityService.AddWorkflowActivity( addModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.ActivityPagingViewElement as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }

  showEditworkflowActivityModal(workflowActivity: any, EditWorkflowActivityModal) {
    this.EditworkflowActivityForm = new FormGroup({})

    //console.log (workflowActivity);
    this.workflowActivityId = workflowActivity.id

    this.EditworkflowActivityNameInEnglish = new TextBoxOptions();
    this.EditworkflowActivityNameInEnglish.Name = "EditNameInEnglish";
    this.EditworkflowActivityNameInEnglish.LabelKey = "NameInEnglish";
    this.EditworkflowActivityNameInEnglish.Type = InputType.Text;
    this.EditworkflowActivityNameInEnglish.Value = workflowActivity.name.english;
    this.EditworkflowActivityNameInEnglish.IsRequired = true;


    this.EditworkflowActivityNameInArabic = new TextBoxOptions();
    this.EditworkflowActivityNameInArabic.Name = "EditNameInArabic";
    this.EditworkflowActivityNameInArabic.LabelKey = "NameInArabic";
    this.EditworkflowActivityNameInArabic.Type = InputType.Text;
    this.EditworkflowActivityNameInArabic.Value = workflowActivity.name.arabic;
    this.EditworkflowActivityNameInArabic.IsRequired = true;
    this.EditworkflowActivityNameInArabic.ForceDirection = ForceDirection.Arabic;


    this.EditworkflowActivityDescriptionInEnglish = new TextBoxOptions();
    this.EditworkflowActivityDescriptionInEnglish.Name = "EditDescriptionInEnglish";
    this.EditworkflowActivityDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.EditworkflowActivityDescriptionInEnglish.Type = InputType.Text;
    this.EditworkflowActivityDescriptionInEnglish.Value = workflowActivity.description != null ? workflowActivity.description.english : "";
    this.EditworkflowActivityDescriptionInEnglish.IsRequired = true;


    this.EditworkflowActivityDescriptionInArabic = new TextBoxOptions();
    this.EditworkflowActivityDescriptionInArabic.Name = "EditDescriptionInArabic";
    this.EditworkflowActivityDescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.EditworkflowActivityDescriptionInArabic.Type = InputType.Text;
    this.EditworkflowActivityDescriptionInArabic.Value = workflowActivity.description != null ? workflowActivity.description.arabic : "";
    this.EditworkflowActivityDescriptionInArabic.IsRequired = true;
    this.EditworkflowActivityDescriptionInArabic.ForceDirection = ForceDirection.Arabic;

    this.EditworkflowActivitySysName = new TextBoxOptions();
    this.EditworkflowActivitySysName.Name = "EditSysName";
    this.EditworkflowActivitySysName.LabelKey = "SysName";
    this.EditworkflowActivitySysName.Type = InputType.Text;
    this.EditworkflowActivitySysName.Value = workflowActivity.sysName;

    this.EditActivityType = new DropdownOptions();
    this.EditActivityType.Name = "EditActivityType"
    this.EditActivityType.LabelKey = "ActivityType"
    this.EditActivityType.DataSource = this.ActivityTypeList
    this.EditActivityType.SingleSelection = true;
    this.EditActivityType.AllowSearchFilter = true;
    this.EditActivityType.Placeholder = "";
    this.EditActivityType.SelectedItems = this.ActivityTypeList.filter((item) => { return parseInt(item.key) == workflowActivity.activityTypeItemID; }).map((item) => item.key)[0];;

    this.modalService.open(EditWorkflowActivityModal);
    this.utilityService.stopBlockUI();
  }
  editworkflowActivity() {
    if (this.EditworkflowActivityForm.invalid) {
      return;
    }
    else {
      this.utilityService.startBlockUI();
      let ResultModel = this.EditworkflowActivityForm.value;
      let EditModel = new WFActivityModel();
      EditModel.ID = Number(this.workflowActivityId);
      EditModel.Name.English = ResultModel.EditNameInEnglish
      EditModel.Name.Arabic = ResultModel.EditNameInArabic
      EditModel.Description.English = ResultModel.EditDescriptionInEnglish
      EditModel.Description.Arabic = ResultModel.EditDescriptionInArabic
      EditModel.SysName = ResultModel.EditSysName
      EditModel.VersionID = Number(this.VersionId);
      EditModel.ActivityTypeItemID = ResultModel.EditActivityType != null ? Number(ResultModel.EditActivityType) : null

      this.workflowActivityService.EditActivity(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.ActivityPagingViewElement as any;
        element.UpdatePaging();
      }, (error) => {
      
      })
    }
  }

}
